import { useEffect } from "preact/hooks";
import { useSignal } from "@preact/signals";

const targetUsers: Record<string, number> = {};

const getElement = (targetId?: string) => {
    const finalTargetId = targetId ? `portal-${targetId}` : null;

    if (finalTargetId) {
        const element = document.getElementById(finalTargetId);

        targetUsers[finalTargetId] = (targetUsers[finalTargetId] ?? 0) + 1;

        if (element) {
            return element as HTMLDivElement;
        }
    }

    const newElement = document.createElement("div");

    if (finalTargetId) {
        newElement.id = finalTargetId;
    }

    document.body.appendChild(newElement);

    return newElement;
};

const cleanElement = (element: HTMLDivElement, targetId?: string) => {
    const finalTargetId = targetId ? `portal-${targetId}` : null;
    const count = finalTargetId ? (targetUsers[finalTargetId] ?? 1) : 1;

    if (count > 1 && finalTargetId) {
        targetUsers[finalTargetId] = count - 1;
    } else if (document.body.contains(element)) {
        document.body.removeChild(element);
    }
};

const usePortalTarget = (targetId?: string) => {
    const target = useSignal<HTMLDivElement | null>(null);

    useEffect(() => {
        const element = getElement(targetId);

        target.value = element;

        return () => {
            cleanElement(element, targetId);

            target.value = null;
        };
    }, [target, targetId]);

    return target;
};

export default usePortalTarget;
